<template>
    <v-row class="row--small">
        <v-spacer />
        <v-col cols="12" md="auto" v-for="{ text, value, icon, items, multiple, clearable } in items" :key="value">
            <v-card flat v-bind="{ loading }">
                <v-select v-model="query[value]" v-bind="{ items, multiple, clearable }" :placeholder="text" :prepend-inner-icon="icon" :key="value" hide-details outlined class="v-input--large w-lg-240px" @change="push">
                    <template #item="{ item }">
                        <v-list-item @click="setFilter({ key: value, value: item.value, multiple })">
                            <v-list-item-icon>
                                <v-simple-checkbox :value="multiple ? query[value]?.includes?.(item.value) : query[value] == item.value" color="primary" @click="setFilter({ key: value, value: item.value, multiple })" />
                            </v-list-item-icon>
                            <v-list-item-title>
                                <p class="page-text grey-9--text">{{ item.text }}</p>
                            </v-list-item-title>
                        </v-list-item>
                    </template>
                </v-select>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import { WORK_EXPERIENCES } from "@/assets/variables";

const initQuery = (query = {}) => {
    query = { ...query };

    query._categories = Array.isArray(query._categories) ? query._categories : [query._categories].filter((item) => item);
    query["employment.place.address1"] = Array.isArray(query["employment.place.address1"]) ? query["employment.place.address1"] : [query["employment.place.address1"]].filter((item) => item);

    if (query["employment.place.address1"].length == 0) query["employment.place.address1"] = ["전체"];

    query["qualification.workExperience.items"] = query["qualification.workExperience.items"] || null;

    return { ...query };
};

const regions = ["전체", "전국", "해외", "서울", "경기", "인천", "부산", "대구", "대전", "광주", "울산", "세종", "강원", "경남", "경북", "전남", "전북", "충남", "충북", "제주"].map((text) => ({ text, value: text }));

export default {
    data: () => ({
        loading: false,
        regions,
        categories: [],

        query: initQuery(),
    }),
    computed: {
        items() {
            return [
                {
                    text: "지역별",
                    value: "employment.place.address1",
                    icon: "icon icon-location",
                    items: this.regions,
                    multiple: true,
                },
                {
                    text: "경력별",
                    value: "qualification.workExperience.items",
                    icon: "icon icon-idcard",
                    items: [{ text: "전체", value: null }, ...Object.values(WORK_EXPERIENCES), { text: "경력무관", value: "isIrrelevant" }],
                    multiple: false,
                },
            ];
        },
    },
    mounted() {
        this.init();
        this.sync();
    },
    methods: {
        async init() {
            this.loading = true;
            try {
            } finally {
                this.loading = false;
            }
        },
        async sync() {
            this.query = initQuery(this.$route.query);
        },

        async push() {
            let { ...query } = this.$route.query;

            delete query.page;

            if (this.query["_categories"]) {
                query["_categories"] = this.query["_categories"];
            } else delete query["_categories"];
            if (this.query["employment.place.address1"]) {
                query["employment.place.address1"] = this.query["employment.place.address1"];

                if (query["employment.place.address1"].includes("전체")) delete query["employment.place.address1"];
            } else delete query["employment.place.address1"];
            if (this.query["qualification.workExperience.items"]) {
                query["qualification.workExperience.items"] = this.query["qualification.workExperience.items"];
            } else delete query["qualification.workExperience.items"];

            this.$router.push({ query });
        },

        setFilter({ key, value, multiple }) {
            if (multiple) {
                if (this.query[key]?.includes?.(value)) {
                    this.query[key] = this.query[key].filter((item) => item != value);
                } else {
                    if (key == "employment.place.address1") {
                        switch (value) {
                            case "전체":
                            case "전국": {
                                this.query[key] = [value];
                                break;
                            }

                            default: {
                                this.query[key].push(value);
                                this.query[key] = this.query[key].filter((item) => !["전체", "전국"].includes(item));
                                break;
                            }
                        }
                    } else this.query[key].push(value);
                }
            } else {
                if (this.query[key] == value) {
                    this.query[key] = null;
                } else {
                    // if (key == "qualification.workExperience.items") {
                    //     switch (value) {
                    //         case "전체": {
                    //             this.query[key] = null;
                    //             break;
                    //         }

                    //         default: {
                    //             this.query[key].push(value);
                    //             this.query[key] = this.query[key].filter((item) => item != "전국");
                    //             break;
                    //         }
                    //     }
                    // } else
                    this.query[key] = value;
                }
            }
            this.push();
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .v-input input::placeholder {
        color: var(--v-grey-base) !important;
    }
    .v-application--is-ltr .v-list-item__icon:first-child {
        margin-right: 10px;
    }
    .v-select__selections {
        overflow: hidden;
        max-height: 20px;
    }
    .v-select__selection--comma {
        margin: 0 4px 0 0;
    }
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
    :v-deep {
        .v-menu__content .v-list-item {
            padding: 0 20px;
        }
    }
    .v-select__selections {
        max-height: 22px;
    }
}
@media (min-width: 1200px) {
}
</style>
